export type Transform = { x: number; y: number; k: number };

export type HitTestNode = {
  id: string;
  x?: number | null;
  y?: number | null;
  radius: number;
};

/**
 * Inverse-transform `point` from screen to world coordinates, then return
 * the id of the nearest node whose radius contains that world point, or null.
 */
export function hitTest(
  nodes: HitTestNode[],
  point: { x: number; y: number },
  transform: Transform,
): string | null {
  const wx = (point.x - transform.x) / transform.k;
  const wy = (point.y - transform.y) / transform.k;

  let bestId: string | null = null;
  let bestDist = Infinity;

  for (const node of nodes) {
    if (node.x == null || node.y == null) continue;
    const dx = wx - node.x;
    const dy = wy - node.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist <= node.radius && dist < bestDist) {
      bestDist = dist;
      bestId = node.id;
    }
  }

  return bestId;
}
